import React from 'react';
import { Helmet } from 'react-helmet';
import MovieCard from '../components/Content/MovieCard';
import '../components/Content/Content.css';

// Sample saved movies data
const savedMovies = [
  {
    id: 1,
    title: 'The Matrix',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BNzQzOTk3OTAtNDQ0Zi00ZTVkLWI0MTEtMDllZjNkYzNjNTc4L2ltYWdlXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    rating: 8.7,
    year: 1999,
  },
  {
    id: 5,
    title: 'The Dark Knight',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTMxNTMwODM0NF5BMl5BanBnXkFtZTcwODAyMTk2Mw@@._V1_.jpg',
    rating: 9.0,
    year: 2008,
  },
  {
    id: 9,
    title: 'Forrest Gump',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BNWIwODRlZTUtY2U3ZS00Yzg1LWJhNzYtMmZiYmEyNmU1NjMzXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    rating: 8.8,
    year: 1994,
  },
];

const MyListPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>My List | Quick Flick</title>
      </Helmet>
      <main>
        <div className="container">
          <div style={{ marginTop: '120px', marginBottom: '20px' }}>
            <h1 className="section-title">My List</h1>
            <p style={{ marginBottom: '20px', color: 'var(--light-gray)' }}>
              Your saved movies and shows appear here. Add more content to your list by clicking the "Add to List" button on any title.
            </p>
            
            {savedMovies.length > 0 ? (
              <div className="movie-grid">
                {savedMovies.map((movie) => (
                  <MovieCard
                    key={movie.id}
                    title={movie.title}
                    imageUrl={movie.imageUrl}
                    rating={movie.rating}
                    year={movie.year}
                  />
                ))}
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '50px 0' }}>
                <h3>Your list is empty</h3>
                <p style={{ color: 'var(--light-gray)', margin: '20px 0' }}>
                  Start adding movies and shows to your list to watch them later.
                </p>
                <button className="btn btn-primary">Browse Content</button>
              </div>
            )}
          </div>
          
          <div style={{ marginTop: '40px' }}>
            <h2 className="section-title">Recommended For You</h2>
            <p style={{ marginBottom: '20px', color: 'var(--light-gray)' }}>
              Based on what you've saved to your list
            </p>
            <div className="movie-grid">
              {[...Array(4)].map((_, index) => {
                const movie = {
                  id: 20 + index,
                  title: ['Inception', 'The Departed', 'Interstellar', 'No Country for Old Men'][index],
                  imageUrl: [
                    'https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_.jpg',
                    'https://m.media-amazon.com/images/M/MV5BMTI1MTY2OTIxNV5BMl5BanBnXkFtZTYwNjQ4NjY3._V1_.jpg',
                    'https://m.media-amazon.com/images/M/MV5BZjdkOTU3MDktN2IxOS00OGEyLWFmMjktY2FiMmZkNWIyODZiXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg',
                    'https://m.media-amazon.com/images/M/MV5BMjA5Njk3MjM4OV5BMl5BanBnXkFtZTcwMTc5MTE1MQ@@._V1_.jpg'
                  ][index],
                  rating: [8.8, 8.5, 8.6, 8.1][index],
                  year: [2010, 2006, 2014, 2007][index],
                };
                
                return (
                  <MovieCard
                    key={movie.id}
                    title={movie.title}
                    imageUrl={movie.imageUrl}
                    rating={movie.rating}
                    year={movie.year}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default MyListPage; 